import React, { useEffect, useState } from "react";

/**
 * The vendor's store logo (Vendor Panel -> Store Settings), shown in every theme's header and footer.
 * Renders `fallback` (the theme's own icon + store name) when the store has no logo or the image cannot load.
 * The logo is shown as uploaded, with no background behind it; owners supply a logo that suits their theme.
 */
export default function StoreLogo({ store, height = 40, maxWidth = 190, fallback = null, className = "" }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [store?.logo]);
  if (!store?.logo || broken) return fallback;
  const img = <img src={store.logo} alt={store.name} onError={() => setBroken(true)} data-testid="store-logo" style={{ height, maxWidth, width: "auto", objectFit: "contain", display: "block" }} />;
  return <span className={`inline-flex items-center ${className}`}>{img}</span>;
}
